import { FuelIcon, FuelTag, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { BluredContent } from 'components/BluredContent';
import React, { FC } from 'react';
import { TruckerInformationProps } from '../types';
import * as Styled from './styled';

const BaseTruckerInformation: FC<TruckerInformationProps> = ({ person, vehicle, isMobile, isLocked }) => (
  <FuelFlex defaultProps={{ flexDirection: 'column' }}>
    <FuelFlex defaultProps={{ gap: 'km1' }}>
      <Styled.Name size="body-sm" color="neutral-strong" weight="bold">
        {person?.name}
      </Styled.Name>
      {!!person?.verified && (
        <Styled.VerifiedIcon>
          <FuelIcon name="verified-check" size="micro" iconStyle="filled" />
        </Styled.VerifiedIcon>
      )}
      {!!person?.isVip && (
        <FuelTag data-testid="tag-vip" label="vip" icon="diamond" iconStyle="filled" shape="rectangle" highlight />
      )}
    </FuelFlex>
    {vehicle?.typeName && vehicle?.bodyName && (
      <FuelTypography
        size={isMobile ? 'caption' : 'overline'}
        weight={isMobile ? 'medium' : 'bold'}
        color="neutral-default"
      >
        <BluredContent blurContent={isLocked}>
          {vehicle?.typeName} | {vehicle?.bodyName}
        </BluredContent>
      </FuelTypography>
    )}
    {person?.areaCodes?.length > 0 && (
      <FuelTypography size="caption" color="neutral-default" weight="bold">
        <BluredContent blurContent={isLocked}>DDD: ({person?.areaCodes.join('), (')})</BluredContent>
      </FuelTypography>
    )}
  </FuelFlex>
);

export default BaseTruckerInformation;
